const AuthService = {
  readJwtToken: (key) => {
    const appJwtToken = sessionStorage.getItem("TOKEN");
    if (appJwtToken) {
      const payload = appJwtToken.split(".")[1];
      let jwtObj = JSON.parse(atob(payload));
      return jwtObj[key];
    }
    return "";
  },

  registerEmail: (email) => {
    sessionStorage.setItem("email", email);
  },

  registerAlertShow: () => {
    sessionStorage.setItem("alert", true);
  },

  getName: () => AuthService.readJwtToken("name"),

  getRole: () => AuthService.readJwtToken("role"),

  storeIpAddress: (ipAddress) => {
    sessionStorage.setItem("ipAddress", JSON.stringify(ipAddress));
  },

  getAuthId: () => AuthService.readJwtToken("userId"),

  getEmpId: () => AuthService.readJwtToken("empid"),

  getGroupId: () => AuthService.readJwtToken("groupId"),

  getmobileNo: () => AuthService.readJwtToken("mobileNo"),

  getUserType: () => AuthService.readJwtToken("uType"),

  getToken: () => {
    let token = "Bearer " + sessionStorage.getItem("TOKEN");
    return token;
  },

  registerToken: (token) => {
    sessionStorage.setItem("TOKEN", token);
  },

  isAuth: () => {
    let user = sessionStorage.getItem("TOKEN");
    return Boolean(user);
  },

  removeAuth: () => {
    console.log("userHas been removed");
    sessionStorage.clear();
  },

  registerUserData: (userData) => {
    sessionStorage.setItem("USER_DATA", JSON.stringify(userData));
  },

  getUserData: () => {
    const data = sessionStorage.getItem("USER_DATA");
    return data ? JSON.parse(data) : null;
  },

  // Optional shortcuts
  getUserId: () => AuthService.getUserData()?.uId || "",
  getUserName: () => AuthService.getUserData()?.uName || "",
  getMobileNo: () => AuthService.getUserData()?.mobileNo || "",
};

export default AuthService;
